import React, { useEffect, useRef, useState } from "react";
import close from "../../assets/images/close.svg";
import { Col, Form, Nav, Row, Tab } from "react-bootstrap";
import Nodata from "../../assets/images/No Data.svg";
import editAction from "../../assets/images/editaction.svg";
import { useDispatch } from "react-redux";
import { UpdateDescription } from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { commonservices } from "../../services/CommonServices";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function WorflowDescription({
  handleshowPopup,
  data,
  id,
  RedirectParam,
  BindDataByID,
  ViewParam,
  editmode,
  setEditMode,
}) {
  const dispatch = useDispatch();
  const textareaRef = useRef(null);

  const navigate = useNavigate();
  // const [editState, setEditState] = useState(editmode);
  const [loading, setLoading] = useState(false);

  const [descriptionData, setDescriptionData] = useState(data);
  const HandelSaveDescription = (e) => {
    if (id == 0) {
      toast.error("Please save the workflow before adding a description.");
      return;
    }
    setLoading(true);
    dispatch(
      UpdateDescription({ workflowid: id, description: descriptionData })
    )?.then(() => {
      setLoading(true);
      setEditMode(false);
      let data = commonservices.bodyEncryption(`${id}?v=0&r=${RedirectParam}`);
      navigate(`/flow-new/${data}`, {
        state: {
          isViewMode: false,
        },
      });
      BindDataByID(id);
      handleshowPopup(e);
    });
  };
  const GetNoData = () => {
    return (
      <div className="text-center">
        <img src={Nodata} alt="No Description" className="mt-5 mb-5" />
        <h5 className="mb-2">No Description Data</h5>
        <p>No description is currently available for this data.</p>
        <p>Please check later for more updates.</p>
        <button
          className="blue-btn mt-2"
          style={{ width: "67%" }}
          onClick={(e) => handleshowPopup(e)}
        >
          Go back{" "}
        </button>
      </div>
    );
  };
  useEffect(() => {
    if (editmode && textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.select();
    }
  }, [editmode]);
  return (
    <Tab.Container
      id="left-tabs-example"
      defaultActiveKey="first"
      className="underlined-tabing"
    >
      {/* {loading && <MainpageLoader />} */}
      <div className="schedular-popup add-project-popup">
        <div className="popup-title">
          <div className="d-flex gap-2 align-items-center">
            <h2>Description</h2>{" "}
            {ViewParam === "0" && (
              <img
                src={editAction}
                alt="edit"
                title="Edit"
                id="description"
                className="cursor-pointer"
                onClick={() => {
                  setEditMode(true);
                }}
              />
            )}
          </div>
          <img
            src={close}
            alt="close"
            id="description"
            className="cursor-pointer"
            onClick={(e) => {
              handleshowPopup(e);
              // setEditMode(false);
            }}
          />
        </div>
        <div className="d-block p-0">
          {/* <Nav variant="pills" className="justifly-content-start">
            <Nav.Item>
              <Nav.Link eventKey="first">Details</Nav.Link>
            </Nav.Item> */}
          {/* <Nav.Item>
              <Nav.Link eventKey="second">Workflow</Nav.Link>
            </Nav.Item> */}
          {/* <Nav.Item>
              <Nav.Link eventKey="third">Schedule</Nav.Link>
            </Nav.Item> */}
          {/* </Nav> */}
        </div>
        <div className="popup-body p-0 d-flex justify-content-between h-100 flex-column">
          <Row className="p-2 m-0">
            <Col xl={12}>
              {/* {data ? ( */}
              <>
                {editmode ? (
                  <Form.Control
                    ref={textareaRef}
                    style={{ minHeight: "270px" }}
                    as="textarea"
                    rows={5}
                    placeholder="Description"
                    className="common-input"
                    maxLength={499}
                    value={descriptionData}
                    onChange={(e) => setDescriptionData(e.target.value)}
                  />
                ) : data ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: descriptionData }}
                    className="text-black"
                  />
                ) : (
                  <GetNoData />
                )}
              </>
              {/* ) : (
                <GetNoData />
              )} */}
              {/* <p className="text-black" >{data ? data : }</p> */}
            </Col>
          </Row>
          {editmode && (
            <div className="popup-footer">
              <button
                className="grey-btn"
                disabled={loading}
                onClick={() => setEditMode(false)}
              >
                Cancel
              </button>
              <button
                className="blue-btn d-inline-block cursor-pointer   btn btn-primary"
                disabled={loading}
                onClick={(e) => HandelSaveDescription(e)}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </div>
    </Tab.Container>
  );
}

export default WorflowDescription;
